import React from 'react'
import { useTranslation } from 'react-i18next'
import { useConfig } from '@context/ConfigurationContext'
import useClinic from '@hooks/useClinic'
import Spinner from '@components/Spinner'
import useStyles from './styles'
import { ERROR_PLEASE_CALL } from 'src/config/imageUrls'
import { Button } from '@components/Button/Button'
import { Phone } from '@components/icons/Phone'
import { onPhoneClick } from 'src/utils/onPhoneClick'
import { getImageUrl } from 'src/utils/getImageUrl'

const Error = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { clinicId } = useConfig()
  const { isLoading, data } = useClinic(clinicId)

  return isLoading ? (
    <Spinner center />
  ) : (
    <div className={classes.root}>
      <img className={classes.image} src={getImageUrl({ src: ERROR_PLEASE_CALL })} alt={'phone'} />
      <p className={classes.text}>{t('error_text')}</p>
      <h3 className={classes.callHeading}>{t('error_call_heading')}</h3>
      <span className={classes.callNow}>{t('error_cta_button_label')}</span>
      <Button
        text={data?.phone}
        phoneSize="xl"
        startIcon={<Phone width={18} height={18} />}
        onClick={() => onPhoneClick(data?.phone)}
      />
    </div>
  )
}

export default Error
